import {PageContinueDto} from '../../common/shared/api/nicolas/vo/PageContinueDto.interface';
import {ServicePropertyDto} from '../../common/shared/api/nicolas/vo/ServicePropertyDto.interface';
import {ServiceProperty} from '../generated/types';
import {createContinueInfo} from './ContinueInfo';
import {createLastViewInfo} from './LastViewInfo';
import {createPreview} from './Preview';
import {createPurchaseInfo} from './PurchaseInfo';
import {createSingleTicketInfo} from './SingleTicketInfo';
import {createTodayGift} from './TodayGift';
import {createWaitfreeTicket} from './WaitfreeTicket';

export function createServiceProperty(
  {
    alarm_on,
    read_count,
    waitfree_ticket,
    comment_count,
    last_view,
    like_on,
    page_continue,
    purchase_info,
    purchased_dt,
    rating_count,
    rating_sum,
    ticket_count,
    ticket_info,
    today_gift,
    preview,
    view_count,
  }: ServicePropertyDto,
  fallback_page_continue?: PageContinueDto,
  seriesId?: number
): ServiceProperty {
  return {
    readCount: read_count,
    waitfreeTicket: waitfree_ticket
      ? createWaitfreeTicket(waitfree_ticket)
      : undefined,
    commentCount: comment_count,
    isAlarmOn: alarm_on,
    isLikeOn: like_on,
    lastViewInfo: last_view ? createLastViewInfo(last_view) : undefined,
    pageContinue: page_continue
      ? createContinueInfo(page_continue, seriesId)
      : fallback_page_continue
        ? createContinueInfo(fallback_page_continue, seriesId)
        : undefined,
    purchaseInfo: purchase_info ? createPurchaseInfo(purchase_info) : undefined,
    purchasedDate: purchased_dt,
    ratingCount: rating_count,
    ratingSum: rating_sum,
    ticketCount: ticket_count,
    ticketInfo: ticket_info ? createSingleTicketInfo(ticket_info) : undefined,
    todayGift: today_gift ? createTodayGift(today_gift) : undefined,
    preview: preview ? createPreview(preview) : undefined,
    viewCount: view_count,
  };
}
